import {stringify} from 'qs';
import type {MetadataId} from 'types';

export const createMetadataLink = ({ean, workId}: MetadataId) => {
  if (workId) {
    const queryParams = ean ? {isbn: ean} : {};

    return `/metadata/${workId}?${stringify(queryParams, {
      skipNulls: true,
    })}`;
  }

  if (ean) {
    return `/metadata/ean/${ean}`;
  }

  return undefined;
};
